<template>
<v-toolbar dark color="primary" clipped-left app v-if="!toolbarDisabled">
  <v-btn icon v-if="toolbarIsBackIcon" @click="$router.go(-1)">
    <v-icon>arrow_back</v-icon>
  </v-btn>

  <v-toolbar-side-icon v-else @click="drawerClick"></v-toolbar-side-icon>

  <img width="36" height="36" :src="logo" class="ml-4 hidden-xs-only" />

  <v-toolbar-title>{{ toolbarTitle }}</v-toolbar-title>

  <v-spacer></v-spacer>

  <slot></slot>

  <v-toolbar-items v-if="enableSearchGateway">
    <search-gateway></search-gateway>
  </v-toolbar-items>

  <v-toolbar-items v-if="enableSearchFuncType">
    <search-functype></search-functype>
  </v-toolbar-items>

  <v-toolbar-items v-if="enableSearchKeyword">
    <search-keyword></search-keyword>
  </v-toolbar-items>

  <v-toolbar-items class="hidden-xs-only">
    <language></language>
  </v-toolbar-items>

  <v-toolbar-items v-if="!userLoading" class="hidden-xs-only">
    <user-avatar v-if="userAvatar"></user-avatar>
    <v-btn v-else flat to="/login">{{ $t('menu.login') }}</v-btn>
  </v-toolbar-items>

</v-toolbar>
</template>

<script>
import UserAuth from '@/components/auth/UserAuth'
import SearchKeywordMenu from './SearchKeywordMenu'
import SearchGatewayMenu from './SearchGatewayMenu'
import SearchFuncTypeMenu from './SearchFuncTypeMenu'
import LanguageMenu from './LanguageMenu'
import UserAvatarMenu from './UserAvatarMenu'

export default {
  name: 'Toolbar',
  mixins: [UserAuth],
  components: {
    'search-keyword': SearchKeywordMenu,
    'search-gateway': SearchGatewayMenu,
    'search-functype': SearchFuncTypeMenu,
    'language': LanguageMenu,
    'user-avatar': UserAvatarMenu
  },
  props: ['logo'],
  methods: {
    drawerClick() {
      this.$emit('drawer', true);
    }
  },
  computed: {
    toolbarTitle() {
      let mac = this.$route.params.mac;
      if (mac) {
        return (this.userMacInfo[mac] || {}).hostname || mac;
      }
      if (this.$route.name == 'app_name') {
        return this.$appName;
      }
      return this.$t(this.$route.name);
    },
    toolbarIsBackIcon() {
      return this.$route.meta.up;
    },
    toolbarDisabled() {
      return this.$route.meta.disableToolbar;
    },
    enableSearchGateway() {
      return this.$route.meta.enableSearchGateway;
    },
    enableSearchKeyword() {
      return this.$route.meta.enableSearchKeyword;
    },
    enableSearchFuncType() {
      return this.$route.meta.enableSearchFuncType;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/utils/Toolbar.vue